// export default (to, from, next) => {
//   if (
//     localStorage.getItem("user") != null &&
//     localStorage.getItem("user").length > 0
//   ) {
//     next();
//   } else {
//     localStorage.removeItem("user");
//     window.reload();
//   }
// };
import RepositoryFactory from "@/repository/factory";
const confUsers = RepositoryFactory.get("confUsers");

export default async (to, from, next) => {
  const response = await confUsers.GetCurrentUser();
  const userInfo = response?.status ? response.data : null;
  if (userInfo) {
    next();
  } else {
    localStorage.removeItem("user");
    next("/user/login");
  }

  // if (localStorage.getItem("user") != null && localStorage.getItem("user").length > 0) {
  //     next();
  // } else {
  //     localStorage.removeItem("user");
  //     next("/user/login");
  // }
};
